<template>
  <v-card
    border
    class="ma-6 pa-4"
  >
    <a
      :href="privacyPolicyUrl"
      class="iubenda-white iubenda-noiframe iubenda-embed iub-body-embed"
      title="Datenschutzerklärung"
      >Datenschutzerklärung</a
    >
  </v-card>
</template>

<script>
import { iubenda } from '@/lib/features'
import iubendaMixin from '@/modules/iubenda/mixin'

export default {
  mixins: [iubendaMixin],
  data: () => ({
    config: iubenda?.config,
  }),

  computed: {
    documentId() {
      return this.config?.documentId?.[this.locale]
    },

    privacyPolicyUrl() {
      return this.documentId
        ? `https://www.iubenda.com/privacy-policy/${this.documentId}`
        : 'https://www.iubenda.com/privacy-policy/32303798'
    },
  },

  mounted() {
    this.loadIubendaScript()
  },

  methods: {
    loadIubendaScript() {
      if (document.querySelector('script[src="https://cdn.iubenda.com/iubenda.js"]')) {
        return
      }

      const script = document.createElement('script')
      script.src = 'https://cdn.iubenda.com/iubenda.js'
      script.async = true
      document.body.appendChild(script)
    },
  },
}
</script>
